import {Suggest} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'

import {DISABLE_AUTOCOMPLETE} from '../../../../externalPackage'
import type {LocationDetectedVariant} from '../../../api/address/model/types'
import {useFetchCityDesktop} from '../../../api/address/pickupPoint'
import {useConfigContext} from '../../../contexts'
import type {Props} from './types'

export function CitySuggest({pointType, onChange}: Props): React.ReactElement {
  const t = useI18n()
  const {location} = useConfigContext()
  const fetchCity = useFetchCityDesktop()

  return (
    <Suggest<LocationDetectedVariant>
      autoComplete={DISABLE_AUTOCOMPLETE}
      fetchSuggest={fetchCity}
      location={location}
      onChange={onChange}
      placeholder={t('ndd.point.point-selector.city_placeholder', 'Введите город или регион')}
      pointType={pointType}
      portal={false}
    />
  )
}
